import {Component, OnDestroy, OnInit} from "@angular/core";
import {ALL_ROLES, WorkflowService} from "../workflow/workflow.service";
import {Subscription} from "rxjs";

@Component({
  selector: "project-missing-roles",
  templateUrl: "./project-missing-roles.template.pug",
})

export class ProjectMissingRolesComponent implements OnInit, OnDestroy {
  private workflowStatusSubscription: Subscription;
  public missingRoles: string[];
  public missingRolesString: string;

  constructor(private workflowService: WorkflowService) {
  }

  ngOnInit(): void {
    this.workflowStatusSubscription = this.workflowService.workflowStatus.subscribe(() => {
      this.updateDisplay();
    });
  }

  ngOnDestroy(): void {
    this.workflowStatusSubscription.unsubscribe();
  }

  updateDisplay(): void {
    if (!this.workflowService.workflowConfig.filledPrivileges) return;
    if (this.workflowService.workflowConfig.type !== "project") return;

    const geoRegionId = this.workflowService.workflowConfig.geoRegionId;

    const requiredRoles = ALL_ROLES.filter(role => role.requiredForRegion.includes(geoRegionId));

    this.missingRoles = requiredRoles
      .filter(role => !this.workflowService.workflowConfig.filledPrivileges.includes(role.key))
      .map(role => role.name);

    this.missingRolesString = this.missingRoles.join(", ");
  }
}
